import { render, staticRenderFns } from "./OrgChartTemp3.vue?vue&type=template&id=31ed2385&scoped=true&"
import script from "./OrgChartTemp3.vue?vue&type=script&lang=js&"
export * from "./OrgChartTemp3.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartTemp3.vue?vue&type=style&index=0&id=31ed2385&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed2385",
  null
  
)

export default component.exports